import { createI18n } from "vue-i18n";

import en from "./locale/en.json"
import pt from "./locale/pt.json"

const messages = {
    en,
    pt,
};

const i18n = createI18n({
    locale: 'pt', // set locale
    fallbackLocale: "pt-BR", // set fallback locale
    messages, // set locale messages
});

export default i18n;